<template>
	<div class="on_sale_table">
		<div class="table" >
			<el-table ref="multipleTable" :height="880" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" :header-cell-style="{color:'#000000'}">
				<el-table-column align="center" prop="custom_id" label="序号" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.$index}}</div>
					</template>
				</el-table-column>
				<template v-if="q_type==0 || q_type == 2">
					<el-table-column align="center" prop="is_correct" label="答对/答错" show-overflow-tooltip>
						<template slot-scope="scope">
							<div>{{scope.row.is_correct==0?'答错':'答对'}}</div>
						</template>
					</el-table-column>
				</template>
				<el-table-column align="center" prop="user_answer" label="用户选择" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="t_title" label="问题" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="t_option_1" label="答案一" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="t_option_2" label="答案二" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="t_option_3"  label="答案三" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.t_option_3||'无答案'}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="t_option_4"  label="答案四" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.t_option_4||'无答案'}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="t_option_5"  label="答案五" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.t_option_5||'无答案'}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="t_option_6"  label="答案六" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.t_option_6||'无答案'}}</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				q_id:'',
				tableData:[],
				tableData:[],
				currentPage: 1, //初始页
				pageSize : 10,
				total_records : 0,
				q_type:'',
				s_id:''
			}
		},
		methods:{
			admin_get_answer_sheet_info(){
				let params={
					act:'admin_get_answer_sheet_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					s_id: this.s_id
				}
				this.$api.admin_get_answer_sheet_info(params).then((res)=>{
					if(res.code==0){
						this.tableData=res.data
					}
				})
			}
		},
		created() {
			this.s_id = this.$route.query.s_id
			this.q_id = this.$route.query.q_id
			this.q_type = this.$route.query.q_type
			this.admin_get_answer_sheet_info()
		}
	}
</script>

<style scoped lang="scss">
	.on_sale_table{
		width: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.table {
		margin-top: 1.44rem;
		width: 87.5rem;
		height: 100%;
		background: #E6E9ED;
		overflow: hidden;
		padding: 1.25rem;
		border-radius: 0.375rem;
	}
	footer {
		width: 87.5rem;
		height: 3.85rem;
		background: #FFFFFF;
		padding: 0 1.25rem;
		box-sizing: border-box;
		justify-content: flex-end;
		border-radius:0 0 0.375rem 0.375rem;
	}
	.all{
		box-sizing: border-box;
		border:1px solid #205DFF;
		color: #205DFF;
		background-color: #FFFFFF;
	}
	.all-active{
		background-color: #205DFF;
		color: #FFFFFF;
		box-sizing: border-box;
	}
</style>